import { Typography } from '@thinknet-gmbh/platform-common-ui';
import styled from 'styled-components';

export const FormElement = styled.div`
  display: flex;

  .ant-form-item {
    width: 288px;
  }

  & > div:first-child {
    margin-right: 48px;
  }
  margin-bottom: 24px;
`;

export const StyledTypography = styled(Typography)`
  margin-top: 24px;
  margin-bottom: 16px;
`;
